import { render, staticRenderFns } from "./EducationSubject.vue?vue&type=template&id=4e641419&"
import script from "./EducationSubject.vue?vue&type=script&lang=js&"
export * from "./EducationSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports